import React from 'react'

import { Navbar, Footer } from '../../../components';
import { Article4Doc } from '../individual';

export default function Article4() {
  return (
    <div className='emas__article1'>
        <Navbar />
        <Article4Doc />
        <Footer />
    </div>
  )
}
